import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ToastrHelper } from '../../../../helpers/toastr.helper';
import { ProjectType } from '../../../../models/projects/project-type.model';
import { FiltersItem } from '../../../../models/shared/filters-item.model';
import { ProjectTypesService } from '../../../../services/projects/project-types.service';
import { WudoTranslatePipe } from '../../../../pipes/wudo-translate.pipe';

@Component({
    selector: 'app-project-types-filters-dropdown',
    templateUrl: './project-types-filters-dropdown.component.html',
})
export class ProjectTypesFiltersDropdownComponent implements OnInit {
    @Output() ready = new EventEmitter();
    @Output() selectionChanged = new EventEmitter();

    private projectTypes: ProjectType[];
    projectTypesFilterItems: FiltersItem[];

    dictionary = environment.dictionary;

    constructor(
        private readonly projectTypesService: ProjectTypesService,
        private readonly toastrHelper: ToastrHelper,
        private readonly wtranslate: WudoTranslatePipe,
    ) {}

    ngOnInit(): void {
        this.loadProjectTypes();
    }

    loadProjectTypes() {
        this.projectTypesService.getProjectTypes().subscribe(
            (projectTypes) => {
                this.projectTypes = projectTypes;
                this.projectTypesFilterItems = this.projectTypes.map(
                    (projectType) =>
                        new FiltersItem(projectType.id, this.wtranslate.transform(projectType.label, 'projectTypes')),
                );

                this.ready.emit();
            },
            (error) => {
                this.toastrHelper.showGenericError(error);
            },
        );
    }

    setSelectedFilters(projectTypesIds: string[]) {
        this.projectTypesFilterItems.forEach((item) => (item.checked = projectTypesIds.includes(item.key)));
    }

    onProjectTypesSelectionChanged() {
        this.selectionChanged.emit();
    }

    resetFilters(): void {
        this.projectTypesFilterItems.forEach((item) => (item.checked = false));
    }

    onSelectionChanged() {
        this.selectionChanged.emit();
    }
}
